"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var ContentLine_1 = require("../contentLine/ContentLine");
var appointmentDetailsStyles_1 = require("./appointmentDetailsStyles");
var date_fns_1 = require("date-fns");
var Translation_1 = require("../../../common/components/presentation/Translation/Translation");
var AppointmentDetails = function (_a) {
    var date = _a.date, period = _a.period, comments = _a.comments;
    var _b, _c;
    var checkoutLite = core_1.useTheme().checkoutLite;
    var styles = appointmentDetailsStyles_1.default();
    var hideAppointmentDate = (_c = (_b = checkoutLite) === null || _b === void 0 ? void 0 : _b.confirmation) === null || _c === void 0 ? void 0 : _c.hideAppointmentDateOnRequestQuote;
    var getFormattedDate = function (value) {
        var date = new Date(value);
        return date_fns_1.format(date, 'yyyy/MM/dd');
    };
    return (<>
      {!hideAppointmentDate && (<core_1.Box data-test="summary:container:appointment_details" className={styles.appointmentDetailsWrapper}>
          <ContentLine_1.default mainContent={<core_1.Typography variant="subtitle1" className={styles.title}>
                <Translation_1.default id="appointmentDetails.header"/>
              </core_1.Typography>} dataTest={"summary:appointment_details:header"}/>
          <ContentLine_1.default mainContent={<core_1.Typography variant="subtitle1">
                <Translation_1.default id="appointmentDetails.label.date"/>
              </core_1.Typography>} secondaryContent={<core_1.Typography variant="subtitle1">
                {date ? getFormattedDate(date) : <Translation_1.default id="appointmentDetails.noPreference"/>}
              </core_1.Typography>} dataTest={"summary:appointment_details:date"}/>
          <ContentLine_1.default mainContent={<core_1.Typography variant="subtitle1">
                <Translation_1.default id="appointmentDetails.label.time"/>
              </core_1.Typography>} secondaryContent={<core_1.Typography variant="subtitle1">
                {period ? period : <Translation_1.default id="appointmentDetails.noPreference"/>}
              </core_1.Typography>} dataTest={"summary:appointment_details:period"}/>
        </core_1.Box>)}
      {!!comments && (<core_1.Box className={styles.appointmentDetailsWrapper}>
          <ContentLine_1.default mainContent={<core_1.Typography variant="subtitle1" className={styles.title}>
                <Translation_1.default id="enquiryForm.label.comments"/>
              </core_1.Typography>} dataTest="summary:enquiryform_comments:details"/>
          <ContentLine_1.default mainContent={<core_1.Typography variant="subtitle1" className={styles.comments}>
                {comments}
              </core_1.Typography>} dataTest="summary:appointment_details:comments"/>
        </core_1.Box>)}
    </>);
};
exports.default = AppointmentDetails;
